import Pagination from './Pagination';
export default Pagination;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/pagination/index.js
// module id = 196
// module chunks = 3